<div class="reading-container">
  <!-- Header with case information -->
  <div class="case-header">
    <span class="case-number">168848442/27/3515</span>
    <span class="case-divider">|</span>
    <span class="case-name">TREVOR BRYAN MARSH</span>
    <span class="case-divider">|</span>
    <span class="case-address">260 HIGH STREET, DY5 4JB</span>
    <div class="search-box">
      <input type="text" placeholder="Search" class="search-input">
      <button class="search-button">🔍</button>
    </div>
  </div>

  <!-- Main content area -->
  <div class="main-content">
    <!-- Left side - Actions -->
    <div class="actions-section">
      <div class="actions-container">
        <h3 class="actions-title">Actions</h3>
        <div class="action-buttons">
          <button 
            class="action-btn charitable-btn" 
            (click)="onCharitableAction()">
            Charitable
          </button>
          <button 
            class="action-btn non-charitable-btn" 
            (click)="onNonCharitableAction()">
            Non-Charitable
          </button>
          <button 
            class="action-btn missing-page-btn" 
            (click)="onMissingPageAction()">
            Missing Page
          </button>
        </div>
      </div>
    </div>

    <!-- Right side - PDF viewer -->
    <div class="pdf-section">
      <!-- Tab buttons with Open in New Window button -->
      <div class="tab-container">
        <div class="tab-buttons">
          <button 
            class="tab-button" 
            [class.active]="activeTab === 'will'"
            (click)="setActiveTab('will')">
            Will
          </button>
          <button 
            class="tab-button" 
            [class.active]="activeTab === 'probate'"
            (click)="setActiveTab('probate')">
            Grant of Probate
          </button>
        </div>
        <button class="open-new-window-btn" (click)="openInNewWindow()">
          Open in New Window
        </button>
      </div>

      <!-- PDF viewer container -->
      <div class="pdf-viewer-container">
        
        <div class="pdf-content">
          <div *ngIf="activeTab === 'will'" class="pdf-display">
            <!-- Will PDF content -->
            <iframe 
              [src]="sanitizedPdfUrl" 
              width="100%" 
              height="100%"
              style="border: none;"
              frameborder="0"
              (load)="onPdfLoad()"
              (error)="onPdfError()">
              <div class="pdf-fallback">
                <h3>PDF Viewer Not Available</h3>
                <p>Your browser does not support embedded PDFs.</p>
                <a [href]="getCurrentPdfUrl()" target="_blank" class="pdf-link">
                  Open Will PDF in New Tab
                </a>
              </div>
            </iframe>
          </div>
          
          <div *ngIf="activeTab === 'probate'" class="pdf-display">
            <!-- Grant of Probate PDF content -->
            <iframe 
              [src]="sanitizedPdfUrl" 
              width="100%" 
              height="100%"
              style="border: none;"
              frameborder="0"
              (load)="onPdfLoad()"
              (error)="onPdfError()">
              <div class="pdf-fallback">
                <h3>PDF Viewer Not Available</h3>
                <p>Your browser does not support embedded PDFs.</p>
                <a [href]="getCurrentPdfUrl()" target="_blank" class="pdf-link">
                  Open Grant of Probate PDF in New Tab
                </a>
              </div>
            </iframe>
          </div>
          
          <div *ngIf="pdfError" class="pdf-error-message">
            <div class="error-content">
              <h3>Unable to Display PDF</h3>
              <p>The PDF file could not be loaded in the viewer.</p>
              <a [href]="getCurrentPdfUrl()" target="_blank" class="pdf-link">
                Click here to open the {{activeTab === 'will' ? 'Will' : 'Grant of Probate'}} PDF in a new tab
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
